import { RenseignementsGeneraux } from "../../model/RenseignementsGeneraux";

export const initialState: RenseignementsGeneraux = {
    prenom: "",
    nom: "",
    courriel: "",
    telephone: "",
    sujet: "",
    message: "",
};